import React from 'react';
import Hero from './components/search-news/Hero';
import Main from './components/search-news/Main';
import ImportantLinksSlider from './components/Home/ImportantLinksSlider';

const SearchNews = () => {
    return (
        <div>
            <Hero />
            <Main />
            <ImportantLinksSlider />
        </div>
    )
}

export default SearchNews;